<template>
	<v-container fluid>
		<v-row no-gutters>
			<v-col cols="12" sm="12" md="4" lg="4" xl="4">
				<v-toolbar-title class="ml-2 mt-2">Calendário Semana</v-toolbar-title>
			</v-col>
			<v-col cols="12" sm="12" md="8" lg="8" xl="8" align="end">
				<v-btn class="ml-2 my-1" color="primary" @click="exportar()">
					<v-icon left>mdi-microsoft-excel</v-icon> Exportar
				</v-btn>
				<v-btn
					class="ml-2 my-1"
					color="primary"
					@click="abrirImportar()"
				>
					<v-icon left>mdi-upload</v-icon> Importar
				</v-btn>
				<v-btn
					class="ml-2 my-1"
					color="primary"
					@click="abrirCadastrar()"
				>
					<v-icon left>mdi-plus</v-icon> Cadastrar
				</v-btn>
			</v-col>
		</v-row>
		<v-card class="mt-2 py-4 px-2" elevation="1">
			<v-row no-gutters class="mb-2">
				<v-col cols="12" sm="12" md="4" lg="4" xl="4">
					<v-text-field
						v-model="busca"
						append-icon="mdi-magnify"
						label="Pesquisar"
						dense
						outlined
						hide-details
					></v-text-field>
				</v-col>
				<v-col cols="12" sm="12" md="6" lg="6" xl="6"> </v-col>
				<v-col cols="12" sm="12" md="2" lg="2" xl="2" align="end">
					<v-btn class="ml-2 my-1" color="primary" @click="filtrar()">
						<v-icon left>mdi-filter</v-icon> Filtrar
					</v-btn>
				</v-col>
			</v-row>
			<v-data-table
				:headers="headers"
				:items="dados"
				:server-items-length="total"
				:items-per-page="10"
				:footer-props="{
					'items-per-page-options': [5, 10, 15, 25, 50, 100],
				}"
				:options.sync="pagination"
				multi-sort
				class="elevation-0"
			>
				<template v-slot:[`item.botao`]="{ item }">
					<v-icon
						small
						class="mr-2"
						color="primary"
						@click="abrirEditar(item)"
						title="Editar"
					>
						mdi-pencil
					</v-icon>
					<v-icon
						small
						class="mr-2"
						color="error"
						@click="abrirExcluir(item)"
						title="Excluir"
					>
						mdi-delete
					</v-icon>
				</template>
			</v-data-table>
		</v-card>

		<v-dialog v-model="dialogo" width="600">
			<v-card>
				<v-card-title class="subtitle-1 primary white--text">
					{{ calendarioSemana.id_calendario_semana ? 'Editar' : 'Cadastrar' }} Calendário Semana
				</v-card-title>
				<v-card-text class="mt-4">
					<v-form v-model="validaForm">
						<v-row no-gutters class="mt-4">
							<v-col
								cols="12"
								sm="12"
								md="6"
								lg="6"
								xl="6"
								class="px-2"
							>
								<MesInput
									outlined
									dense
									label="Mês"
									v-model="calendarioSemana.mes"
								></MesInput>
							</v-col>
							<v-col
								cols="12"
								sm="12"
								md="6"
								lg="6"
								xl="6"
								class="px-2"
							>
								<v-text-field
									outlined
									dense
									label="Semana"
									v-model="calendarioSemana.semana"
									type="number"
								></v-text-field>
							</v-col>
							<v-col
								cols="12"
								sm="12"
								md="6"
								lg="6"
								xl="6"
								class="px-2"
							>
								<DataInput
									outlined
									dense
									label="Data Início"
									v-model="calendarioSemana.data_inicial_semana"
								></DataInput>
							</v-col>
							<v-col
								cols="12"
								sm="12"
								md="6"
								lg="6"
								xl="6"
								class="px-2"
							>
								<DataInput
									outlined
									dense
									label="Data Fim"
									v-model="calendarioSemana.data_final_semana"
								></DataInput>
							</v-col>
						</v-row>
					</v-form>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						color="primary"
						class="pr-4"
						@click="dialogo = false"
					>
						<v-icon left>mdi-close</v-icon> Fechar
					</v-btn>
					<v-btn
						color="primary"
						class="pr-4"
						:disabled="!validaForm"
						@click="salvar()"
					>
						<v-icon left>mdi-content-save</v-icon> Salvar
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogoImportar" width="90%">
			<v-card>
				<v-card-title class="subtitle-1 primary white--text">
					Importar CSV
				</v-card-title>
				<v-card-text>
					<v-alert
						class="mt-4"
						text
						type="info"
						border="left"
						style="font-size: 12px;"
					>
						<ul>
							<li>
								A base utilizada para importação deve ser
								parecida com o exemplo abaixo.
							</li>
							<li>
								As colunas <strong>MES</strong>, <strong>SEMANA</strong>,
								<strong>DATA_INICIAL</strong> e <strong>DATA_FINAL</strong> 
								são obrigatórias (<strong>e os nomes devem ser idênticos</strong>).
							</li>
							<li>
								O formato do <strong>MES</strong> deve ser <strong>MM/AAAA</strong> 
								(Ex: 01/2025, 02/2025).
							</li>
							<li>
								O formato das datas deve ser <strong>DD/MM/AAAA</strong> 
								(Ex: 01/01/2025, 31/12/2025).
							</li>
							<li>
								<strong>Exemplo de formato CSV:</strong><br>
								<code>
									MES;SEMANA;DATA_INICIAL;DATA_FINAL<br>
									01/2025;1;01/01/2025;07/01/2025<br>
									01/2025;2;08/01/2025;14/01/2025
								</code>
							</li>
						</ul>
					</v-alert>
					<v-row no-gutters>
						<v-col cols="8" class="px-2">
							<v-form ref="form" v-model="isCsv">
								<v-file-input
									label="Arquivo CSV"
									outlined
									dense
									v-model="arquivoCSV"
									:rules="regra.csv"
									accept=".csv"
								></v-file-input>
							</v-form>
						</v-col>
						<v-col cols="4" class="px-2">
							<v-btn
								color="primary"
								:disabled="!isCsv"
								@click="importar()"
							>
								<v-icon left>mdi-upload</v-icon>
								Importar Arquivo
							</v-btn>
						</v-col>
					</v-row>
					<v-expand-transition>
						<div v-show="erro">
							<v-row no-gutters class="mb-0">
								<v-col cols="6">
									<download-csv
										:data="erros"
										:labels="errosLabels"
										name="erros.csv"
										delimiter=";"
									>
										<v-btn color="primary">
											<v-icon left
												>mdi-microsoft-excel</v-icon
											>
											Exportar Erros
										</v-btn>
									</download-csv>
								</v-col>
							</v-row>
							<v-data-table
								:headers="headerErros"
								:items="erros"
								:items-per-page="5"
								:options.sync="paginationErros"
								class="elevation-0 data-table-2"
							></v-data-table>
						</div>
					</v-expand-transition>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						color="primary"
						class="pr-4"
						@click="dialogoImportar = false"
					>
						<v-icon left>mdi-close</v-icon> Fechar
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-overlay :value="carregando" :z-index="300">
			<v-progress-circular indeterminate size="64"></v-progress-circular>
		</v-overlay>

		<v-snackbar
			v-model="alerta"
			:color="alertaColor"
			:timeout="alertaTimeout"
			top
			style="z-index: 400"
		>
			<v-alert :type="alertaColor">
				{{ alertaTexto }}
			</v-alert>
			<v-btn dark text class="float-right" @click="alerta = false">
				Fechar
			</v-btn>
		</v-snackbar>
	</v-container>
</template>

<script>
export default {
	components: {
		DataInput: () => import("@/components/DataInput.vue"),
		MesInput: () => import("@/components/MesInput.vue"),
	},
	data() {
		return {
			headers: [
				{ text: "ID", value: "id_calendario_semana", align: "center" },
				{ text: "Mês", value: "mes_formatado", align: "center" },
				{ text: "Semana", value: "semana", align: "center" },
				{ text: "Data Início", value: "data_inicial_formatada", align: "center" },
				{ text: "Data Fim", value: "data_final_formatada", align: "center" },
				{ text: "Criado em", value: "data_criacao_formatada", align: "center" },
				{ text: "Criado por", value: "usuario_criacao", align: "center" },
				{ text: "", value: "botao", align: "center", sortable: false },
			],
			dados: [],
			calendarioSemana: {
				id_calendario_semana: null,
				mes: null,
				semana: null,
				data_inicial_semana: null,
				data_final_semana: null,
			},
			pagination: {},
			paginationErros: {},
			total: null,
			carregando: false,
			busca: null,
			dialogo: false,
			dialogoImportar: false,
			validaForm: false,
			alerta: false,
			alertaTexto: "",
			alertaColor: "error",
			alertaTimeout: 3000,
			arquivoCSV: null,
			regra: {
				csv: [
					(v) => !!v || "Selecione um arquivo.",
					(v) =>
						(!!v && [".csv", ".CSV"].includes(v.name.substr(-4))) ||
						"O arquivo deve ser do tipo CSV.",
				],
			},
			isCsv: false,
			headerErros: [
				{ text: "Descrição do Erro", value: "msg", align: "left" },
			],
			erros: [],
			errosLabels: { msg: "Descrição do Erro" },
			erro: false,
		};
	},
	watch: {
		pagination: {
			handler() {
				this.filtrar();
			},
			deep: true,
		},
		busca(v) {
			setTimeout(() => {
				if (v == this.busca) {
					this.filtrar();
				}
			}, 1500);
		},
	},
	methods: {
		async filtrar() {
			this.carregando = true;

			try {
				var data = {};

				data.pagination = this.pagination;
				data.busca = this.busca;

				var response = await this.$http().post("/calendarioSemana/lista", {
					data: data,
				});

				this.dados = response.data;

				this.total = response.data.length ? response.data[0].total : 0;

				if (this.total == 0 && this.pagination.page > 1) {
					this.pagination.page = 1;
					this.filtrar();
				}
			} catch (error) {
				console.error("Erro ao carregar calendário semana:", error);
				this.alerta = true;
				this.alertaColor = "error";
				this.alertaTimeout = 5000;
				this.alertaTexto = "Erro ao carregar dados. Verifique se a API está funcionando.";
				this.dados = [];
				this.total = 0;
			}

			this.carregando = false;
		},
		async exportar() {
			this.carregando = true;

			try {
				var data = {};

				var response = await this.$http().post("/calendarioSemana/exportar", {
					data: data,
				});

				window.location = this.$http("baseURL") + response.data.url;
			} catch (error) {
				console.error("Erro ao exportar:", error);
				this.alerta = true;
				this.alertaColor = "error";
				this.alertaTimeout = 5000;
				this.alertaTexto = "Erro ao exportar dados.";
			}

			this.carregando = false;
		},
		abrirEditar(item) {
			this.calendarioSemana = { 
				id_calendario_semana: item.id_calendario_semana,
				semana: item.semana,
				mes: item.mes_formatado || null,
				data_inicial_semana: item.data_inicial_formatada || null,
				data_final_semana: item.data_final_formatada || null,
			};

			this.dialogo = true;
		},
		abrirCadastrar() {
			this.calendarioSemana = {
				id_calendario_semana: null,
				mes: null,
				semana: null,
				data_inicial_semana: null,
				data_final_semana: null,
			};

			this.dialogo = true;
		},
		async salvar() {
			this.carregando = true;

			try {
				var data = {
					mes: this.calendarioSemana.mes,
					semana: this.calendarioSemana.semana,
					data_inicial_semana: this.calendarioSemana.data_inicial_semana,
					data_final_semana: this.calendarioSemana.data_final_semana,
				};

				// Define qual endpoint usar
				const endpoint = this.calendarioSemana.id_calendario_semana 
					? "/calendarioSemana/editar" 
					: "/calendarioSemana/salvar";

				// Se tiver ID, inclui no objeto para edição
				if (this.calendarioSemana.id_calendario_semana) {
					data.id_calendario_semana = this.calendarioSemana.id_calendario_semana;
				}

				var response = await this.$http().post(endpoint, {
					data: data,
				});

				if (response.data.sucesso) {
					this.filtrar();
					this.dialogo = false;
					this.alerta = true;
					this.alertaColor = "success";
					this.alertaTimeout = 3000;
					this.alertaTexto = this.calendarioSemana.id_calendario_semana 
						? "Registro atualizado com sucesso!" 
						: "Registro cadastrado com sucesso!";
				} else {
					this.alerta = true;
					this.alertaColor = "error";
					this.alertaTimeout = -1;
					
					let mensagem = '';
					if (response.data.erros && response.data.erros.length > 0) {
						mensagem += "\n" + response.data.erros.map(erro => "• " + erro).join("\n");
					}
					this.alertaTexto = mensagem;
				}
			} catch (error) {
				console.error("Erro ao salvar:", error);
				this.alerta = true;
				this.alertaColor = "error";
				this.alertaTimeout = 5000;
				this.alertaTexto = "Erro ao salvar dados.";
			}

			this.carregando = false;
		},
		abrirExcluir(item) {
			this.$dialog.confirm({
				title: "Confirmar exclusão",
				text: `Deseja realmente excluir a semana ${item.semana} do mês ${item.mes_formatado}?`,
				actions: {
					false: "Cancelar",
					true: {
						text: "Excluir",
						color: "error",
						handle: () => {
							this.excluir(item.id_calendario_semana);
						},
					},
				},
			});
		},
		async excluir(id) {
			this.carregando = true;

			try {
				var response = await this.$http().post("/calendarioSemana/deletar", {
					data: { ids: [id] },
				});

				if (response.data.sucesso) {
					this.filtrar();
					this.alerta = true;
					this.alertaColor = "success";
					this.alertaTimeout = 3000;
					this.alertaTexto = "Registro excluído com sucesso!";
				} else {
					this.alerta = true;
					this.alertaColor = "error";
					this.alertaTimeout = -1;
					
					let mensagem = '';
					if (response.data.erros && response.data.erros.length > 0) {
						mensagem += "\n" + response.data.erros.map(erro => "• " + erro).join("\n");
					}
					this.alertaTexto = mensagem;
				}
			} catch (error) {
				console.error("Erro ao excluir:", error);
				this.alerta = true;
				this.alertaColor = "error";
				this.alertaTimeout = 5000;
				this.alertaTexto = "Erro ao excluir dados.";
			}

			this.carregando = false;
		},
		abrirImportar() {
			this.arquivoCSV = null;
			this.erro = false;

			try {
				this.$refs.form.resetValidation();
			} catch (error) {
				//console.log(error)
			}

			this.dialogoImportar = true;
		},
		async importar() {
			this.carregando = true;

			var data = {};

			var formData = new FormData();

			formData.append("files", this.arquivoCSV);
			formData.append("data", JSON.stringify(data));

			this.arquivoCSV = null;

			try {
				this.$refs.form.resetValidation();
			} catch (error) {
				//console.log(error)
			}

			try {
				var response = await this.$http().post(
					"/calendarioSemana/importar",
					formData
				);

				if (response.data.sucesso) {
					this.filtrar();
					this.dialogoImportar = false;
					this.alerta = true;
					this.alertaColor = "success";
					this.alertaTimeout = 3000;
					this.alertaTexto = "Importação realizada com sucesso!";
				} else {
					this.filtrar();
					this.erros = response.data.erros;
					this.pagination.page = 1;
					this.erro = true;
				}
			} catch (error) {
				console.error("Erro ao importar:", error);
				this.alerta = true;
				this.alertaColor = "error";
				this.alertaTimeout = 5000;
				this.alertaTexto = "Erro ao importar dados.";
			}

			this.carregando = false;
		},
	},
};
</script>
